



















































































































































































































































import Vue from 'vue'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { cloneDeep } from 'lodash'

interface ComponentData {
  rules: Array<Function>
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  saveInProgress: boolean

  employeePhoto: string | undefined
  recruitingData: any | null
  isMobilePhoneEdit: boolean
  isMailEdit: boolean
  isBusinessMailEdit: boolean
  isPhoneEdit: boolean
  isPhonePlusEdit: boolean
  isWhatsAppEdit: boolean
  strengthenList: any[]
  weaknessesList: any[]
}

export default Vue.extend({
  name: 'RecruitingDetailDialog',

  components: { },

  props: {
    showDialog: Boolean,
    dialogData: Object as () => any
  },

  data (): ComponentData {
    return {
      rules: [(value: any): boolean | string => !!value || ''],
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      saveInProgress: false,

      employeePhoto: 'https://avatars0.githubusercontent.com/u/9064066?v=4&s=460',
      recruitingData: null,
      isMobilePhoneEdit: false,
      isMailEdit: false,
      isBusinessMailEdit: false,
      isPhoneEdit: false,
      isPhonePlusEdit: false,
      isWhatsAppEdit: false,
      strengthenList: [
        {id: 1, text:''}
      ],
      weaknessesList: [
        {id: 1, text:''}
      ]
    }
  },

  watch: {},

  computed: {
    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    }
  },

  methods: {
    onCloseDialog (): void {
      this.$emit('close')
    },

    onPhotoClick (): void {
      //this.showUpdatePhotoDialog = true
    },

    onPlusStrengthenClick (): void {
      this.strengthenList.push(
          {id: this.strengthenList.length -1 , text:''}
      )
    },

    onPlusWeaknessesClick (): void {
      this.weaknessesList.push(
          {id: this.strengthenList.length -1 , text:''}
      )
    },

    onCancelDialog (): void {
      this.recruitingData = cloneDeep(this.dialogData)
      //@ts-ignore
      this.$refs['form'].resetValidation()
    },

    onSaveButtonClick (): void {
      //@ts-ignore
      if(this.$refs['form'].validate()) {

      }
    }
  },

  mounted (): void {
    if(!this.dialogData.id) {
      this.isMobilePhoneEdit = true
      this.isMailEdit = true
      this.isBusinessMailEdit = true
      this.isPhoneEdit = true
      this.isPhonePlusEdit = true
      this.isWhatsAppEdit = true
    }

    this.recruitingData = cloneDeep(this.dialogData)
  }
})
